import styles from './style.postcss';

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import GroupStatus from 'components/GroupStatus';
import SessionCourseSwitch from './SessionCourseSwitch';
import { connect, Button, ConfirmDialog, ColourLabel } from 'omni-common-ui';
import { actions as uiState } from 'data/UiState';
import { actions as syncGroupAction } from 'containers/Group';
import PropTypes from 'prop-types';
import { hasMidtermOrFinalExam } from 'data/ProgressTestsPlan/accessors';

class GroupInfoBar extends Component {
  constructor(props) {
    super(props);
    this._setSessionCourseSwitchMode = this._setSessionCourseSwitchMode.bind(this);
    this._syncGroupInfo = this._syncGroupInfo.bind(this);
    this.state = {
      shouldPopupDialog: false,
    };
  }

  _setSessionCourseSwitchMode(viewMode) {
    this.props.toggleViewMode(viewMode || (this.props.viewMode !== 'day' ? 'day' : 'course'));
  }

  _syncGroupInfo() {
    const group = this.props.group;
    this.props.syncGroupInfo(group.id)
      .then(() => this._toggleConfirmDialog(true));
  }

  _syncGroupConfirmDialog() {
    return <ConfirmDialog isOpen={this.state.shouldPopupDialog}
        primaryButtonContent="Ok"
        onPrimaryClick={() => this._toggleConfirmDialog(false)}>
      <span>Get latest information after several seconds.</span>
    </ConfirmDialog>;
  }

  _toggleConfirmDialog(isDialogShow) {
    this.setState({ shouldPopupDialog: isDialogShow });
  }

  _renderGroupExternalLink() {
    const group = this.props.group;
    const groupUrl = group.groupExternalUrl;

    return <a className={styles.GroupInfoBar_info_scheduling} href={groupUrl} target="_blank">
      <Button>{group.isFromOdin ? 'Odin+' : 'Scheduling' }</Button>
    </a>;
  }

  render() {
    const {
      group,
      params,
      routes,
      push,
      buildRoute,
      viewMode,
      isMidtermOrFinalExamExist,
    } = this.props;

    if (! group) {
      return null;
    }

    return <div className={styles.GroupInfoBar}>
      <div className={styles.GroupInfoBar_wrap}>
        <div className={styles.GroupInfoBar_wrap_section}>
          <div className={styles.GroupInfoBar_info}>
            <span className={styles.GroupInfoBar_info_summary}>{group.name} | {group.number}</span>
            {this._renderGroupExternalLink()}
            <Button className={styles.GroupInfoBar_info_refresh}
                onClick={this._syncGroupInfo}>
              Refresh
            </Button>
          </div>
          <GroupStatus status={group.status} />
          <span style={{ marginRight: '10px' }} />
          {isMidtermOrFinalExamExist && <ColourLabel text="MT/F" colour="#8e4cc8" />}
        </div>
        <div className={styles.GroupInfoBar_wrap_section}>
          <SessionCourseSwitch params={params}
              toggle={this._setSessionCourseSwitchMode}
              viewMode={viewMode}
              routes={routes}
              redirect={push}
              buildRoute={buildRoute} />
        </div>
      </div>
      {this._syncGroupConfirmDialog()}
    </div>;
  }
}

GroupInfoBar.propTypes = {
  group: PropTypes.shape({
    name: PropTypes.string,
    number: PropTypes.string,
    status: PropTypes.string,
    isFromOdin: PropTypes.bool,
    groupExternalUrl: PropTypes.string,
  }),
  params: PropTypes.shape({}),
  location: PropTypes.shape({}),
  routes: PropTypes.arrayOf(PropTypes.shape({})),
  push: PropTypes.func.isRequired,
  buildRoute: PropTypes.func.isRequired,
  toggleViewMode: PropTypes.func.isRequired,
  viewMode: PropTypes.string,
  syncGroupInfo: PropTypes.func.isRequired,
  groupId: PropTypes.string,
  isMidtermOrFinalExamExist: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  const groupId = ownProps.params.groupId;
  const viewMode = uiState.getViewMode(state);
  const group = state.get('rootReducer').get('groups').get(groupId);
  const isMidtermOrFinalExamExist = hasMidtermOrFinalExam(state, groupId);

  return {
    viewMode,
    groupId,
    group: group && group.data,
    isMidtermOrFinalExamExist,
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({},
     bindActionCreators(uiState, dispatch),
     bindActionCreators(syncGroupAction, dispatch),
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupInfoBar);



// WEBPACK FOOTER //
// ./containers/Group/GroupInfoBar/index.jsx